/* eslint-disable no-unused-vars */

import { createApi } from '@reduxjs/toolkit/query/react';
import { configs } from '../../../../Utils/Common/configs';
import { axiosBaseQuery } from '../../../../Axios/AxiosBaseQuery';

// Create the API using createApi
export const GetApplicationShortApi = createApi({
  reducerPath: 'GetApplicationShortApi',
  tagTypes: [
    'section-info',
    'batch-detail',
    'get-enrolment',
    'section-feedback',
    'get-id-doc',
    'videoList',
  ],
  baseQuery: axiosBaseQuery({
    baseUrl: configs.REACT_APP_BASE_URL,
  }),
  staleTime: 1,
  endpoints: (builder) => ({
    getApplicationSectionInfo: builder.query({
      query: () => ({ url: 'intern-service/application/section-info', method: 'GET' }),
      providesTags: ['section-info'],
    }),
    getCurrentApplication: builder.query({
      query: () => ({ url: 'intern-service/application', method: 'GET' }),
    }),
    profile: builder.query({
      query: () => ({ url: 'intern-service/login-intern-details', method: 'GET' }),
    }),
    batch: builder.query({
      query: () => ({ url: 'intern-service/application/batch-detail', method: 'GET' }),
      providesTags: ['batch-detail'],
    }),
    payment: builder.query({
      query: () => ({ url: 'intern-service/application/payments', method: 'GET' }),
    }),
    getEnrolment: builder.query({
      query: () => ({ url: 'intern-service/application/enrol', method: 'GET' }),
      providesTags: ['get-enrolment'],
    }),
    getIDDocument: builder.query({
      query: () => ({ url: 'intern-service/application/list-identity-document', method: 'GET' }),
      providesTags: ['get-id-doc'],
    }),
    saveEnrolment: builder.mutation({
      query: (data) => ({ url: 'intern-service/application/enrol', method: 'POST', body: data }),
      invalidatesTags: (result, error) =>
        error ? [] : ['get-enrolment', 'section-info', 'get-id-doc'],
    }),
    uploadIDDocument: builder.mutation({
      query: (data) => ({
        url: 'intern-service/application/create-identity-document',
        method: 'POST',
        body: data,
      }),
    }),
    submitApplication: builder.mutation({
      query: (isResubmit) => ({
        url: isResubmit
          ? 'intern-service/application/re-submit-application'
          : 'intern-service/application/submit',
        method: 'POST',
      }),
      invalidatesTags: (result, error) => (error ? [] : ['section-info']),
    }),
    startApplication: builder.mutation({
      query: () => ({
        url: 'intern-service/application/start',
        method: 'POST',
      }),
      invalidatesTags: (result, error) => (error ? [] : ['batch-detail', 'section-info']),
    }),
    shareReview: builder.mutation({
      query: (body) => ({
        url: 'intern-service/profile/review-feedback',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error) => (error ? [] : ['section-info', 'section-feedback']),
    }),
    getSectionWiseFeedback: builder.query({
      query: (data) => ({
        url: `intern-service/profile/feedback?section=${data.section}`,
        method: 'GET',
      }),
      providesTags: ['section-feedback'],
    }),
    getVideos: builder.query({
      query: () => ({ url: 'intern-service/profile/video/list', method: 'GET', body: null }),
      providesTags: ['videoList'],
    }),
    createVideoAnswers: builder.mutation({
      query: (body) => {
        const url = 'intern-service/profile/video/create';
        return { url, method: 'POST', body };
      },
      invalidatesTags: (result, error) => (error ? [] : ['videoList', 'section-info']),
    }),
    confirmEnrolment: builder.mutation({
      query: () => {
        const url = 'intern-service/application/final-enrol';
        return { url, method: 'PATCH' };
      },
      invalidatesTags: (result, error) => (error ? [] : ['section-info']),
    }),
    updateInternshipStartDate: builder.mutation({
      query: (payload) => {
        const url = 'intern-service/application/internship-start-date';
        return { url, method: 'PATCH', body: payload };
      },
      invalidatesTags: (result, error) => (error ? [] : ['get-enrolment']),
    }),
  }),
});

// Export hooks for usage in components
export const {
  useGetApplicationSectionInfoQuery,
  useGetCurrentApplicationQuery,
  useProfileQuery,
  useBatchQuery,
  usePaymentQuery,
  useGetEnrolmentQuery,
  useGetIDDocumentQuery,
  useSaveEnrolmentMutation,
  useUploadIDDocumentMutation,
  useSubmitApplicationMutation,
  useStartApplicationMutation,
  useShareReviewMutation,
  useGetSectionWiseFeedbackQuery,
  useGetVideosQuery,
  useCreateVideoAnswersMutation,
  useConfirmEnrolmentMutation,
  useUpdateInternshipStartDateMutation,
} = GetApplicationShortApi;
// Export the auto-generated hooks and reducer
export default GetApplicationShortApi.reducer;
export const getApplicationShortState = (state) => state.GetApplicationShortApi;
